import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { CustomOrderData } from '@fiverr-private/seller_pages_toolbox';

export interface CustomOrderModalData {
    data: null | CustomOrderData;
    shouldOpen: boolean;
}

const customOrderModalAtom = atom<CustomOrderModalData>({
    data: null,
    shouldOpen: false,
});

export const useCustomOrderModal = () => useAtomValue(customOrderModalAtom);

const createCustomOrderHandler = (shouldOpen: boolean) => () => {
    const setCustomOrderModal = useSetAtom(customOrderModalAtom);

    const handler = useCallback(
        (newData?: CustomOrderModalData['data']) => {
            setCustomOrderModal((prevState) => ({
                data: newData !== undefined ? newData : prevState.data,
                shouldOpen,
            }));
        },
        [setCustomOrderModal]
    );

    return handler;
};

export const useCustomOrderModalOpen = createCustomOrderHandler(true);

export const useCustomOrderModalClose = createCustomOrderHandler(false);
